import * as partials from "../partials/types";

export const CAMPAIGN_VIEW = partials.createRequestTypes("CAMPAIGN_VIEW");
export const LOAD_CAMPAIGN_VIEW = "LOAD_CAMPAIGN_VIEW";

export * from "../partials/types";
